import moment from "moment"
import Service from "../../../Services/index";

const Payment = {
    namespaced: true,
    state: {
        payments: [],
        search: {
            start_date: null,
            end_date: null
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
        paymentForm: {
            billing_id: null,
            invoice_id: null,
            transaction_type_id: 3,
            transactions: [
                {
                    ref_no: null,
                    date: null,
                    amount: 0
                }
            ]
        },
        paymentLimit: 0
    },
    mutations: {
        SET_PAYMENTS: (state, res) => {
            state.payments = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        SET_SEARCH: (state, search) => {
            state.search = {
                ...search
            }
        },
        SET_BILLING_ID: (state, billingId) => {
            state.paymentForm.billing_id = billingId
        },
        SET_INVOICE_ID: (state, invoiceId) => {
            state.paymentForm.invoice_id = invoiceId
        },
        SET_PAYMENT_LIMIT: (state, amount) => {
            state.paymentLimit = amount
            state.paymentForm.transactions = [
                {
                    ...state.paymentForm.transactions[0],
                    amount: amount
                }
            ]
        },
        ADD_PAYMENT_TRANSACTION: state => {
            state.paymentForm.transactions = [
                ...state.paymentForm.transactions,
                {
                    ref_no: null,
                    date: null,
                    amount: 0
                }
            ]
        },
        SET_TRANSACTIONS_FOR_CASH: state => {
            state.paymentForm.transactions = [
                {
                    ref_no: null,
                    date: null,
                    amount: state.paymentLimit
                }
            ]
        },
        RESET_PAYMENT_FORM: state => {
            state.paymentForm = {
                billing_id: null,
                invoice_id: null,
                transaction_type_id: 3,
                transactions: [
                    {
                        ref_no: null,
                        date: null,
                        amount: 0
                    }
                ]
            }
        }
    },
    actions: {
        setPayments({state, commit}) {
            return Service.Payment.getPayments({
                page: state.current_page,
                ...state.search
            })
                .then(data => {
                    commit("SET_PAYMENTS", data)
                })
        },
        setSearch({commit}, search) {
            commit("SET_SEARCH", search)
        },
        setBillingId({commit}, billingId) {
            commit("SET_BILLING_ID", billingId)
        },
        setInvoiceId({commit}, invoiceId) {
            commit("SET_INVOICE_ID", invoiceId)
        },
        setPaymentLimit({commit}, amount) {
            commit("SET_PAYMENT_LIMIT", amount)
        },
        addPaymentTransaction({commit}) {
            commit("ADD_PAYMENT_TRANSACTION")
        },
        setTransactionsForCash({commit}) {
            commit("SET_TRANSACTIONS_FOR_CASH")
        },
        resetPaymentForm({commit}) {
            commit("RESET_PAYMENT_FORM")
        },
        createPayment({state}) {
            //console.log(state.paymentForm);
            let data = {
                billing_id: state.paymentForm.billing_id,
                invoice_id: state.paymentForm.invoice_id,
                transactions: state.paymentForm.transactions.map(transaction => ({
                    ...transaction,
                    transaction_type_id: state.paymentForm.transaction_type_id,
                    date: moment(transaction.date).format("YYYY-MM-DD")
                }))
            };
            //console.log("payment");
            //console.log(data);
            return Service.Payment.createPayment(data);
        },
        getDataSumary({commit}, data) {
            return Service.Payment.getDataSumary(data)
        }
    }
};

export default Payment
